const themeColors = {
  primary: '#267aff',
  purple: '#995efc',
  slate: '#6575ff',
  aqua: '#29c3ff',
  turquoise: '#00cbb8',
  yellow: '#ffaa10',
  orange: '#ff8225',
  tomato: '#ff6a4c',
  gray: '#7c879b',
  white: '#ffffff',
  dark: '#000000',
  colmo: '#000000'
}

export { themeColors }



// WEBPACK FOOTER //
// ./constant/theme.js